module.exports = __webpack_public_path__ + "img/arrow-green.8ea7f593.svg";